<script>
  import { Line } from 'vue-chartjs'

  export default {
    extends: Line,
    props: {
      chartData: {
        type: [Array, Object],
        required: false
      },
      chartLabels: {
        type: Array,
        required: true
      },
      annotations: {
        type: Array,
        default: () => []
      },
      userAnnotations: {
        type: Array,
        default: () => []
      },
      height: {
        type: String
      }
    },
    data () {
      return {
        options: {
          scales: {
            yAxes: [{
              ticks: {
                stepSize: 1,
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }],
            xAxes: [ {
              gridLines: {
                display: true
              }
            }]
          },
          legend: {
            display: false
          },
          responsive: true,
          maintainAspectRatio: false
        }
      }
    },
    methods: {
      render: function () {
        this.renderChart({
          labels: this.chartLabels,
          datasets: [
            {
              label: 'Crises',
              borderColor: '#249EBF',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              pointBorderColor: '#249EBF',
              backgroundColor: 'transparent',
              data: this.chartData
            }
          ]
        }, this.options)
      }
    },
    watch:{
      chartLabels:function () {
        this.render()
      },
      chartData: function () {
        this.render()
      },
      annotations: function () {
        this.render()
      },
      userAnnotations: function () {
        this.render()
      }
    },
    mounted () {
      const self = this

      const tooltip = document.createElement('div')
      tooltip.style.cssText = [
        'position:fixed',
        'background:rgba(0,0,0,0.78)',
        'color:#fff',
        'padding:6px 10px',
        'border-radius:4px',
        'font-size:12px',
        'line-height:1.5',
        'pointer-events:none',
        'display:none',
        'max-width:240px',
        'word-break:break-word',
        'white-space:pre-wrap',
        'z-index:9999',
        'box-shadow:0 2px 8px rgba(0,0,0,0.3)'
      ].join(';')
      document.body.appendChild(tooltip)
      this._annTooltip = tooltip

      const canvas = this.$refs.canvas

      canvas.addEventListener('mousemove', (e) => {
        const chart = self.$data._chart
        const hasAnnotations = (self.annotations && self.annotations.length) || (self.userAnnotations && self.userAnnotations.length)
        if (!chart || !hasAnnotations) {
          tooltip.style.display = 'none'
          return
        }

        const xAxis = chart.scales['x-axis-0']
        const yAxis = chart.scales['y-axis-0']
        const rect = canvas.getBoundingClientRect()
        const mouseX = e.clientX - rect.left
        const mouseY = e.clientY - rect.top

        if (mouseY < yAxis.top || mouseY > yAxis.bottom) {
          tooltip.style.display = 'none'
          return
        }

        let found = null
        ;(self.annotations || []).forEach(ann => {
          const idx = chart.data.labels.indexOf(ann.date)
          if (idx === -1) return
          const x = xAxis.getPixelForValue(null, idx, 0, false)
          if (Math.abs(mouseX - x) < 12) found = ann
        })
        if (!found) {
          (self.userAnnotations || []).forEach(ann => {
            const idx = chart.data.labels.indexOf(ann.date)
            if (idx === -1) return
            const x = xAxis.getPixelForValue(null, idx, 0, false)
            if (Math.abs(mouseX - x) < 12) found = ann
          })
        }

        if (found) {
          tooltip.style.display = 'block'
          tooltip.style.left = (e.clientX + 14) + 'px'
          tooltip.style.top = (e.clientY - 10) + 'px'
          tooltip.textContent = found.text || found.date
        } else {
          tooltip.style.display = 'none'
        }
      })

      canvas.addEventListener('mouseleave', () => {
        tooltip.style.display = 'none'
      })

      this.addPlugin({
        id: 'vertical-annotations',
        afterDraw (chart) {
          const ctx = chart.ctx
          const xAxis = chart.scales['x-axis-0']
          const yAxis = chart.scales['y-axis-0']

          ;(self.annotations || []).forEach(ann => {
            const idx = chart.data.labels.indexOf(ann.date)
            if (idx === -1) return
            const x = xAxis.getPixelForValue(null, idx, 0, false)
            ctx.save()
            ctx.beginPath()
            ctx.moveTo(x, yAxis.top)
            ctx.lineTo(x, yAxis.bottom)
            ctx.lineWidth = 2
            ctx.strokeStyle = 'rgba(245, 0, 87, 0.75)'
            ctx.setLineDash([6, 3])
            ctx.stroke()
            ctx.restore()
          })

          ;(self.userAnnotations || []).forEach(ann => {
            const idx = chart.data.labels.indexOf(ann.date)
            if (idx === -1) return
            const x = xAxis.getPixelForValue(null, idx, 0, false)
            ctx.save()
            ctx.beginPath()
            ctx.moveTo(x, yAxis.top)
            ctx.lineTo(x, yAxis.bottom)
            ctx.lineWidth = 2
            ctx.strokeStyle = 'rgba(25, 118, 210, 0.85)'
            ctx.setLineDash([6, 3])
            ctx.stroke()
            ctx.restore()
          })
        }
      })
      this.render()
    },
    beforeDestroy () {
      if (this._annTooltip) {
        document.body.removeChild(this._annTooltip)
        this._annTooltip = null
      }
    }
  }
</script>
